import React from "react";

export const RemediosIcon = ({
  size = "32",
  className,
}: {
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={size}
      className={className}
      width={size}
    >
      <path d="M88,274.3H54.92a9.57,9.57,0,0,1-9.56-9.56V77.45a9.57,9.57,0,0,1,9.56-9.57H170.28a9.55,9.55,0,0,1,9.55,9.51l-.47,109.3a12.62,12.62,0,0,0,12.57,12.68H192a12.62,12.62,0,0,0,12.63-12.57l.47-109.35a34.74,34.74,0,0,0-32.23-34.56v-22a21,21,0,0,0-21-21H73.36a21,21,0,0,0-21,21v22A34.77,34.77,0,0,0,20.1,77.45V264.74a34.85,34.85,0,0,0,34.82,34.81H88a12.63,12.63,0,1,0,0-25.25ZM77.59,27.87a2.76,2.76,0,0,1,2.75-2.76h64.51a2.76,2.76,0,0,1,2.75,2.76v12a2.75,2.75,0,0,1-2.74,2.75H80.33a2.75,2.75,0,0,1-2.74-2.75Z" />
      <path d="M126.66,164.41V144.49h19.66a6.51,6.51,0,0,0,6.51-6.52V123.4a6.51,6.51,0,0,0-6.51-6.51H126.66V97a6.52,6.52,0,0,0-6.51-6.52H105.58A6.52,6.52,0,0,0,99.06,97v19.92H78.88a6.52,6.52,0,0,0-6.52,6.51V138a6.52,6.52,0,0,0,6.52,6.52H99.06v19.92a6.51,6.51,0,0,0,6.52,6.51h14.57A6.51,6.51,0,0,0,126.66,164.41Z" />
      <path d="M237.05,210.79H152.92a42.08,42.08,0,0,0-42,42.05v4.66a42.08,42.08,0,0,0,42,42.05h84.13A42.09,42.09,0,0,0,279.1,257.5v-4.66A42.09,42.09,0,0,0,237.05,210.79Zm26.26,46.71a26.28,26.28,0,0,1-26.26,26.25H195l.08-57.16h42a26.28,26.28,0,0,1,26.26,26.25Z" />
    </svg>
  );
};
